var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2136_9387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.57 13.44L3 16.5V4.26C3.00286 4.06062 3.07741 3.86893 3.21 3.72C3.27621 3.65139 3.35538 3.59661 3.44293 3.55884C3.53048 3.52108 3.62466 3.50107 3.72 3.5H15.28C15.3753 3.50107 15.4695 3.52108 15.5571 3.55884C15.6446 3.59661 15.7238 3.65139 15.79 3.72C15.9226 3.86893 15.9971 4.06062 16 4.26V12.68C15.9971 12.8794 15.9226 13.0711 15.79 13.22C15.7238 13.2886 15.6446 13.3434 15.5571 13.3812C15.4695 13.4189 15.3753 13.4389 15.28 13.44H6.57Z",
    stroke: "#F4A460",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 13.5V16.68C7.00063 16.7808 7.02128 16.8804 7.06077 16.9731C7.10025 17.0658 7.15778 17.1498 7.23 17.22C7.37727 17.3628 7.57487 17.4419 7.78 17.44H17.15L21 20.5V8.26003C20.9994 8.15927 20.9787 8.05964 20.9392 7.96693C20.8997 7.87423 20.8422 7.7903 20.77 7.72003C20.6227 7.57723 20.4251 7.49819 20.22 7.50003H16.33",
    stroke: "#F4A460",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2136_9387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact-icon.d74207f2e556da13db4f06b82b4596fd.svg";
export { ForwardRef as ReactComponent };